import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|Scheduling|Scheduling|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ExamScheduling,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateHistoryScheduling';
export type SPCandidateHistorySchedulingLocNames =
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}TitleTable`
	| `${LocNameStart}ButtonCriteria`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelCode`
	| `${LocNameStart}LabelGroup`;

export const spCandidateHistorySchedulingLocs: LocDefs<SPCandidateHistorySchedulingLocNames> = {
	SPCandidateHistorySchedulingTitleTab: {
		defaultValue: 'Available Exams',
		description: 'Tab Title',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		legacyName: 'Exam.Scheduling/Candidates.Scheduling.Title.Tab',
		...sharedProperties,
	},
	SPCandidateHistorySchedulingTitleTable: {
		defaultValue: 'Scheduling Table',
		description: 'Table Title',
		displayPath: `${pathStart}Table Title`,
		displayType: 'Title',
		legacyName: 'Exam.Scheduling/Candidates.Scheduling.Title.Table',
		...sharedProperties,
	},
	SPCandidateHistorySchedulingButtonCriteria: {
		defaultValue: 'Criteria',
		description: 'Criteria button',
		displayPath: `${pathStart}Criteria button`,
		displayType: 'Button',
		legacyName: 'Exam.InformationUrl/Candidates.Scheduling.Button.Criteria',
		...sharedProperties,
        feature: HubFeature.ExamInformationUrl,
	},
	SPCandidateHistorySchedulingLabelName: {
		defaultValue: 'Name',
		description: 'Column heading for: Name.',
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		legacyName: 'Exam.Scheduling/Candidates.Scheduling.ColumnHeading.ExamName',
		...sharedProperties,
	},
	SPCandidateHistorySchedulingLabelCode: {
		defaultValue: 'Code',
		description: 'Column heading for: Code.',
		displayPath: `${pathStart}Code`,
		displayType: 'Label',
		legacyName: 'Exam.Scheduling/Candidates.Scheduling.ColumnHeading.ExamCode',
		...sharedProperties,
	},
	SPCandidateHistorySchedulingLabelGroup: {
		defaultValue: 'Group',
		description: 'Column heading for: Group.',
		displayPath: `${pathStart}Group`,
		displayType: 'Label',
		legacyName: 'Exam.Scheduling/Candidates.Scheduling.ColumnHeading.ExamGroup',
		...sharedProperties,
	},
};

export type SPCandidateHistorySchedulingLocType = LocMap<SPCandidateHistorySchedulingLocNames>;
